const messages = {
  it: {
    translations: {
      common: {
        yes: "Sì",
        no: "No",
        save: "Salva",
        cancel: "Annulla",
        confirm: "Conferma",
        delete: "Elimina",
        edit: "Modifica",
        add: "Aggiungi",
        create: "Crea",
        update: "Aggiorna",
        close: "Chiudi",
        back: "Indietro",
        next: "Avanti",
        previous: "Precedente",
        search: "Cerca",
        loading: "Caricamento...",
        noData: "Nessun dato",
        error: "Errore",
        success: "Successo",
        warning: "Attenzione"
      },
      signup: {
        title: "Registrati",
        toasts: {
          success: "Utente creato con successo! Effettua il login.",
          disabled:
            "La registrazione utente è attualmente disabilitata. Riprova più tardi.",
          fail: "Errore nella creazione dell'utente. Verifica i dati inseriti.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Password",
          company: "Nome Organizzazione",
          phone: "WhatsApp (Prefisso + Numero)",
        },
        buttons: {
          submit: "Registrati",
          login: "Hai già un account? Accedi!",
        },
      },
      login: {
        title: "Accedi",
        welcomeBack: "Bentornato",
        subtitle: "Inserisci le tue credenziali per accedere",
        heroTitle: "Gestisci le tue conversazioni in un unico posto",
        heroDescription:
          "Centralizza ticket, messaggi e clienti con un accesso sicuro, veloce e ordinato per tutto il team.",
        form: {
          email: "Email",
          password: "Password",
          button: "Accedi",
        },
        buttons: {
          submit: "Accedi",
          register: "Non hai un account? Registrati",
          forgotPassword: "Password dimenticata?",
        },
      },
      companies: {
        title: "Registra Azienda",
        form: {
          name: "Nome Azienda",
          plan: "Piano",
          token: "Token",
          submit: "Registra",
          success: "Azienda creata con successo!",
        },
        toasts: {
          loadError: "Impossibile caricare l'elenco delle aziende.",
          saveSuccess: "Operazione completata con successo!",
          saveError: "Impossibile completare l'operazione. Verifica se esiste già un'azienda con lo stesso nome o se i campi sono stati compilati correttamente.",
          deleteSuccess: "Operazione completata con successo!",
          deleteError: "Impossibile completare l'operazione."
        }
      },
      auth: {
        toasts: {
          success: "Login effettuato con successo!",
        },
        dueDate: {
          expiration: "Il tuo abbonamento scade tra",
          days: "giorni!",
          day: "giorno!",
          expirationToday: "Il tuo abbonamento scade oggi!",
        },
        token: "Token",
      },
      dashboard: {
        filters: {
          show: "Mostra Filtri",
          hide: "Nascondi Filtri",
        },
        filter: "FILTRO ",
        tabs: {
          indicators: "Indicatori",
          assessments: "NPS",
          attendants: "Agenti",
        },
        sections: {
          indicators: "Indicatori",
          satisfactionSurvey: "Sondaggio di Soddisfazione",
          attendances: "Assistenza",
          ratingIndex: "Indice di Valutazione",
          attendants: "Agenti",
        },
        nps: {
          score: "Punteggio",
          promoters: "Promotori",
          neutrals: "Neutri",
          detractors: "Detrattori",
        },
        attendances: {
          total: "Totale Assistenze",
          waitingRating: "In Attesa di Valutazione",
          withoutRating: "Senza Valutazione",
          withRating: "Valutate",
        },
        export: {
          attendantsReport: "Report Agenti",
          attendantsReportFileName: "report-agenti.xlsx",
        },
        charts: {
          perDay: {
            title: "Assistenze oggi: ",
          },
        },
        cards: {
          inAttendance: "In Corso",
          waiting: "In Attesa",
          activeAttendants: "Agenti Attivi",
          finalized: "Finalizzati",
          newContacts: "Nuovi Contatti",
          totalReceivedMessages: "Messaggi Ricevuti",
          totalSentMessages: "Messaggi Inviati",
          averageServiceTime: "Tempo Medio di Servizio",
          averageWaitingTime: "Tempo Medio di Attesa",
          status: "Stato (Attuale)",
          activeTickets: "Ticket Attivi",
          passiveTickets: "Ticket Passivi",
          groups: "Gruppi",
        },
        users: {
          name: "Nome",
          numberAppointments: "Numero Assistenze",
          statusNow: "Stato Attuale",
          totalCallsUser: "Totale Assistenze per Utente",
          totalAttendances: "Totale Assistenze",
        },
        date: {
          initialDate: "Data Inizio",
          finalDate: "Data Fine",
        },
        licence: {
          available: "Disponibile fino al",
        },
        assessments: {
          totalCalls: "Totale Assistenze",
          callsWaitRating: "In Attesa di Valutazione",
          callsWithoutRating: "Senza Valutazione",
          ratedCalls: "Valutate",
          evaluationIndex: "Indice di Valutazione",
          score: "Punteggio",
          prosecutors: "Promotori",
          neutral: "Neutri",
          detractors: "Detrattori",
        },
      },
      reports: {
        title: "Report di Ricerca",
        operator: "Operatore",
        period: "Periodo",
        until: "Fino a",
        date: "Data",
        reportTitle: "Report",
        calls: "Assistenze",
        search: "Sondaggi",
        durationCalls: "Durata Assistenze",
        grupoSessions: "Assistenze di Gruppo",
        groupTicketsReports: {
          timezone: "Europe/Rome",
          msgToast: "Generazione report compresso in corso, attendere.",
          errorToast: "Errore nella generazione del report",
          back: "Indietro",
          groupServiceReport: "Report Assistenza Gruppi",
          loading: "Caricamento...",
          contact: "Contatto",
          dateOpen: "Data Apertura",
          dateLastUpdated: "Data Ultimo Aggiornamento",
          agent: "Agente",
          agentClosed: "Agente Chiusura",
          waitingAssistance: "In Attesa di Assistenza",
          process: "In Corso",
        },
        researchReports: {
          response: "Risposta",
          active: "(Attivo)",
          inactive: "(Inattivo)",
          quantity: "Quantità",
          percentage: "Percentuale",
          title: "Report di Ricerca",
          activeSearch: "Sondaggio Attivo",
          inactiveSearch: "Sondaggio Inattivo",
        },
        ticketDurationDetail: {
          msgToast: "Generazione report compresso in corso, attendere.",
          title: "Report Durata Assistenza",
          startService: "Inizio Servizio",
          lastUpdated: "Ultimo Aggiornamento",
          lastAgent: "Ultimo Agente",
          durationFinished: "Durata Dopo Chiusura",
        },
        ticketDuration: {
          title: "Report Durata Assistenza",
          contact: "Contatto",
          open: "Aperto",
          pending: "In Attesa",
          finished: "Finalizzato",
          durationFinished: "Durata Assistenze Finalizzate",
          durationAfterFinished: "Durata Dopo Chiusura",
          actions: "Azioni",
        },
        ticketReports: {
          msgToast: "Generazione report compresso in corso, attendere.",
          title: "Report Assistenza",
        },
        exportExcel: {
          title: "Report Assistenza",
          startDate: "Data Inizio",
          endDate: "Data Fine",
          notInformed: "Non informato",
          columns: {
            id: "ID",
            connection: "Connessione",
            contact: "Contatto",
            user: "Utente",
            queue: "Coda",
            status: "Stato",
            lastMessage: "Ultimo Messaggio",
            openDate: "Data Apertura",
            openTime: "Ora Apertura",
            closeDate: "Data Chiusura",
            closeTime: "Ora Chiusura",
            supportTime: "Tempo Supporto",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Elenco Assistenze Completate",
          exportTitle: "Elenco Assistenze Gruppo Completate",
        },
      },
      todo: {
        newTask: "Nuova Attività",
        add: "Aggiungi",
        task: "Attività",
      },
      audioRecorder: {
        recordButton: "Registra Audio",
        recordingLabel: "Registrando...",
        recordedLabel: "Audio registrato - {{time}}",
        recordedHelp: "Clicca su ✓ per confermare o su 🗑️ per eliminare",
      },
      contactImportWpModal: {
        title: "Esporta Contatti in Excel",
        buttons: {
          downloadModel: "Scarica modello Excel per importazione",
          closed: "Chiudi",
          import: "Seleziona file Excel per importare Contatti",
        },
      },
      connections: {
        title: "Connessioni",
        waitConnection: "Attendi... Le tue connessioni verranno riavviate!",
        newConnection: "Nuova Connessione",
        restartConnections: "Riavvia Connessioni",
        callSupport: "Chiama Supporto",
        transferTickets: "Trasferisci Ticket",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          "Collega i tuoi canali di servizio per ricevere messaggi e iniziare conversazioni con i tuoi clienti.",
        client: "Cliente",
        connectedConnections: "Connessioni attive",
        disconnectedConnections: "Connessioni disattive",
        totalConnections: "Totale connessioni",
        total: "Totale",
        connections: "Connessioni:",
        channel: "Canale",
        whatsappOfficial: "WhatsApp Ufficiale",
        connectNewAccount: "Collega nuovo account",
        selectChannel: "Seleziona il canale",
        pageName: "Nome della pagina",
        instagramHandle: "Handle Instagram",
        badges: {
          linked: "Vincolato",
        },
        channelDescriptions: {
          whatsapp: "QR code e gestione sessioni classiche.",
          facebook: "Collega le pagine Facebook e ricevi messaggi Messenger.",
          instagram: "Collega il profilo business e centralizza i direct.",
        },
        steps: {
          stepOne: "Passaggio 1",
          stepTwo: "Passaggio 2",
          loginFacebook: "Accedi a Facebook",
          selectPage: "Seleziona la Pagina",
          selectInstagram: "Seleziona il profilo Instagram",
        },
        facebook: {
          success: "Connessione Facebook stabilita con successo!",
        },
        transfer: {
          title: "Trasferimento Ticket",
          description: "Per trasferire i ticket, seleziona la",
          descriptionBold1: "connessione di origine",
          descriptionMiddle: "(da dove verranno spostati i ticket) e la",
          descriptionBold2: "connessione di destinazione",
          descriptionEnd: "(dove verranno trasferiti i ticket). Tutte le chat attive della connessione di origine verranno spostate in quella di destinazione.",
          origin: "Origine",
          destination: "Destinazione",
          transferButton: "TRASFERISCI",
          cancel: "ANNULLA",
          selectConnections: "Seleziona connessioni di origine e destinazione",
          differentConnections: "Le connessioni di origine e destinazione devono essere diverse",
          successMessage: "Ticket trasferiti con successo!",
          successMessageWithCount: "Trasferimento riuscito: {{count}} ticket trasferiti.",
          transferComplete: "Trasferimento completato!",
          transferError: "Errore nel trasferimento dei ticket.",
          progressTitle: "Trasferimento Ticket",
          progressDescription: "Avanzamento Trasferimento",
          progressMessage: "di",
          progressMessageEnd: "ticket trasferiti",
          progressWait: "Attendi mentre i ticket vengono trasferiti...",
          preDeleteTitle: "Trasferimento Ticket",
          preDeleteMessage: "Prima di eliminare questa connessione, hai già trasferito i ticket su un'altra connessione?",
          preDeleteNo: "NO",
          preDeleteYes: "SÌ",
        },
        syncTemplates: {
          tooltip: "Sincronizza template",
        },
        copyWebhook: {
          tooltip: "Copia webhook per Meta",
        },
        toasts: {
          deleted: "Connessione eliminata con successo!",
          closedimported:
            "Chiusura ticket importati in corso, attendere qualche istante.",
        },
        confirmationModal: {
          closedImportedTitle: "Chiudi ticket importati",
          closedImportedMessage:
            "Confermando, tutti i ticket importati verranno chiusi.",
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata.",
          disconnectTitle: "Disconnetti",
          disconnectMessage:
            "Sei sicuro? Dovrai scansionare nuovamente il QR Code.",
        },
        buttons: {
          add: "Aggiungi Connessione",
          disconnect: "Disconnetti",
          tryAgain: "Riprova",
          qrcode: "QR CODE",
          newQr: "NUOVO QR CODE",
          closedImported: "Chiudi tutti i ticket importati",
          preparing: "Preparazione messaggi per importazione",
          importing: "Importazione Messaggi WhatsApp",
          processed: "Processati",
          in: "di",
          connecting: "Connessione in corso",
          connect: "Collega",
          disconnectSocial: "Scollega",
          loginWithFacebook: "Login with Facebook",
        },
        typography: {
          processed: "Processati",
          in: "di",
          date: "Data Messaggio",
        },
        toolTips: {
          disconnected: {
            title: "Errore login WhatsApp",
            content:
              "Assicurati che il telefono sia connesso a internet e riprova, o richiedi un nuovo QR Code.",
          },
          qrcode: {
            title: "In attesa scansione QR Code",
            content:
              "Clicca sul pulsante 'QR CODE' e scansionalo con il tuo telefono per avviare la sessione.",
          },
          connected: {
            title: "Connessione stabilita!",
          },
          timeout: {
            title: "Connessione persa con il telefono",
            content:
              "Assicurati che il telefono sia connesso a internet e WhatsApp sia aperto, o clicca 'Disconnetti' per ottenere un nuovo QR Code.",
          },
        },
        table: {
          channel: "Canale",
          name: "Nome",
          status: "Stato",
          lastUpdate: "Ultimo Aggiornamento",
          default: "Predefinito",
          actions: "Azioni",
          session: "Sessione",
          number: "Numero",
          color: "Colore",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Assistenza Esistente",
        },
        form: {
          message: "Questo contatto è già in assistenza:",
          user: "Agente",
          queue: "Coda",
          messageWait:
            "Questo contatto è già in attesa di servizio. Controlla la scheda In Attesa!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Log",
        },
        options: {
          create: "Ticket creato.",
          chatBot: "ChatBot avviato.",
          queue: "- Coda assegnata.",
          open: "ha iniziato il servizio.",
          access: "ha effettuato l'accesso al ticket.",
          transfered: "ha trasferito il ticket.",
          receivedTransfer: "ha ricevuto il ticket trasferito.",
          pending: "è tornato in coda.",
          closed: "ha chiuso il ticket.",
          reopen: "ha riaperto il ticket.",
          redirect: "- reindirizzato",
          clientClosed: "Il cliente ha chiuso il ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Aggiungi Connessione",
          edit: "Modifica Connessione",
        },
        tabs: {
          general: "Generale",
          messages: "Messaggi",
          assessments: "NPS",
          integrations: "Integrazioni",
          schedules: "Orari di Lavoro",
        },
        form: {
          importOldMessagesEnable: "Importa messaggi dal dispositivo",
          importOldMessages: "Data inizio importazione",
          importRecentMessages: "Data fine importazione",
          importOldMessagesGroups: "Importa messaggi di gruppo",
          closedTicketsPostImported: "Chiudi ticket dopo importazione",
          name: "Nome",
          queueRedirection: "Reindirizzamento Coda",
          queueRedirectionDesc:
            "Seleziona una coda per i contatti senza coda assegnata",
          default: "Predefinito",
          group: "Permetti gruppi",
          timeSendQueue: "Tempo in minuti per reindirizzare alla coda",
          importAlert:
            "ATTENZIONE: Salvare terminerà la connessione. Dovrai scansionare nuovamente il QR Code per importare i messaggi.",
          groupAsTicket: "Tratta gruppi come ticket",
          timeCreateNewTicket: "Crea un nuovo ticket dopo X minuti",
          maxUseBotQueues: "Invia bot X volte",
          maxUseInactiveTime: "Invia flusso inattività X volte",
          timeUseBotQueues: "Invia bot in X minuti",
          timeToReturnQueue: "Tempo per tornare alla coda in minuti",
          timeAwaitActiveFlow: "Tempo attesa flusso attivo",
          expiresTicket: "Chiudi chat aperte dopo X minuti",
          expiresTicketNPS: "Chiudi chat in attesa valutazione dopo X minuti",
          maxUseBotQueuesNPS: "Max volte invio valutazione",
          closeLastMessageOptions1: "Da agente/cliente",
          closeLastMessageOptions2: "Solo da agente",
          outOfHoursMessage: "Messaggio fuori orario",
          greetingMessage: "Messaggio di benvenuto",
          complationMessage: "Messaggio di completamento",
          lgpdLinkPrivacy: "Link privacy policy",
          lgpdMessage: "Messaggio di benvenuto LGPD",
          lgpdDeletedMessages: "Offusca messaggi eliminati per contatto",
          lgpdSendMessage: "Richiedi sempre conferma dal contatto",
          ratingMessage: "Messaggio di Valutazione - La scala deve essere da 0 a 10",
          token: "Token per integrazione esterna",
          sendIdQueue: "Coda",
          inactiveMessage: "Messaggio avviso inattività",
          timeInactiveMessage: "Tempo in minuti per inviare avviso inattività",
          flowInactiveTime: "Tempo in minuti per inviare flusso inattività",
          whenExpiresTicket: "Chiudi chat quando l'ultimo messaggio è",
          expiresInactiveMessage: "Messaggio chiusura per inattività",
          prompt: "Prompt",
          collectiveVacationEnd: "Data fine",
          collectiveVacationStart: "Data inizio",
          collectiveVacationMessage: "Messaggio ferie collettive",
          queueIdImportMessages: "Coda per importazione messaggi",
          isOficial: "Ufficiale",
          phone_number_id: "ID Numero Telefono",
          waba_id: "ID WABA",
          send_token: "Token Invio",
          business_id: "ID Business",
          phone_number: "Numero di telefono",
          triggerIntegrationOnClose: "Attiva Integrazione alla Chiusura",
          enableIntegration: "Integrazione Abilitata",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        menuItem: {
          enabled: "Abilitato",
          disabled: "Disabilitato",
          minutes: "minuti",
        },
        success: "Connessione salvata con successo.",
        errorSendQueue:
          "Hai impostato un tempo di reindirizzamento ma non hai selezionato nessuna coda. Entrambi i campi sono richiesti.",
        errorExpiresNPS: "Deve essere impostato un tempo di attesa per la valutazione NPS.",
        errorRatingMessage: "Deve essere fornito un messaggio di valutazione per NPS.",
      },
      qrCode: {
        message: "Scansiona il QR Code per avviare la sessione",
      },
      contacts: {
        title: "Contatti",
        status: {
          active: "Attivo",
          inactive: "Inattivo",
        },
        toasts: {
          deleted: "Contatto eliminato con successo!",
        },
        searchPlaceholder: "Cerca...",
        conversationFlows: "Flussi di Conversazione",
        addFlow: "Aggiungi Flusso",
        editFlow: "Modifica Flusso",
        confirmationModal: {
          deleteTitle: "Elimina",
          importTitlte: "Importa Contatti",
          exportContact: "Esporta Contatti",
          deleteMessage:
            "Sei sicuro di voler eliminare questo contatto? Tutte le assistenze correlate verranno perse.",
          blockContact: "Sei sicuro di voler bloccare questo contatto?",
          unblockContact: "Sei sicuro di voler sbloccare questo contatto?",
          importMessage: "Vuoi importare tutti i contatti dal telefono?",
          importChat: "Importa Chat",
          wantImport: "Vuoi importare tutte le chat dal telefono?",
        },
        buttons: {
          import: "Importa Contatti",
          add: "Aggiungi Contatto",
          export: "Esporta Contatto",
        },
        table: {
          name: "Nome",
          whatsapp: "Connessione",
          email: "Email",
          ownerPhone: "Telefono associato",
          actions: "Azioni",
          lastMessage: "Ultimo Messaggio",
          wallet: "Portafoglio",
          status: "Stato",
          photo: "Foto",
          id: "ID",
        },
        menu: {
          importYourPhone: "Importa dal dispositivo predefinito",
          importToExcel: "Importa/Esporta da Excel",
          importexport: "IMPORTA / ESPORTA",
          deleteAllContacts: "Elimina Tutti i Contatti",
        },
        bulk: {
          selectAll: "Seleziona tutti i contatti",
          selected: "selezionati",
          allSelected: "(TUTTI)",
          deleteSelected: "Elimina Selezionati",
          deleteAll: "Elimina Tutto",
          cancelSelection: "Annulla",
          noSelection: "Seleziona almeno un contatto per eliminare",
        },
        modal: {
          profilePhoto: "Foto Profilo",
          imageUnavailable: "Immagine non disponibile",
          selectContact: "Seleziona contatto",
          blocked: "Bloccato",
          active: "Attivo",
          notAssigned: "Non assegnato",
          userNotFound: "Utente non trovato",
        },
      },
      forwardMessage: {
        text: "Inoltrato",
      },
      forwardMessageModal: {
        title: "Inoltra Messaggio",
        buttons: {
          ok: "Inoltra",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voce",
          max_tokens: "Token Massimi Risposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Messaggi Massimi Cronologia",
          voiceKey: "API Key Voce",
          voiceRegion: "Regione Voce",
        },
        validation: {
          tooShort: "Troppo corto!",
          tooLong: "Troppo lungo!",
          required: "Richiesto",
          describeAI: "Descrivi l'addestramento per l'Intelligenza Artificiale",
          informVoiceMode: "Inserisci modalità voce",
          informMaxTokens: "Inserisci numero massimo token",
          informTemperature: "Inserisci temperatura",
          informApiKey: "Inserisci API Key",
          informQueue: "Inserisci coda",
          informMaxMessages: "Inserisci numero massimo messaggi",
          selectQueue: "Seleziona settore",
        },
        voices: {
          text: "Testo",
        },
        success: "Prompt salvato con successo!",
        title: {
          add: "Aggiungi Prompt",
          edit: "Modifica Prompt",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
      },
      prompts: {
        title: "Prompt",
        table: {
          name: "Nome",
          queue: "Settore/Coda",
          max_tokens: "Token Massimi Risposta",
          actions: "Azioni",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? Questa azione non può essere annullata!",
        },
        buttons: {
          add: "Aggiungi Prompt",
        },
        toasts: {
          permissionError: "Questa azienda non ha il permesso per accedere a questa pagina! Ti stiamo reindirizzando.",
        },
      },
      contactModal: {
        title: {
          add: "Aggiungi Contatto",
          edit: "Modifica Contatto",
        },
        form: {
          mainInfo: "Dati Contatto",
          extraInfo: "Informazioni Aggiuntive",
          name: "Nome",
          number: "Numero WhatsApp",
          email: "Email",
          extraName: "Nome Campo",
          extraValue: "Valore",
          chatBotContact: "Disabilita Chatbot",
          termsLGDP: "Termini LGPD accettati il:",
          whatsapp: "Connessione di Origine:",
        },
        buttons: {
          addExtraInfo: "Aggiungi Informazione",
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Contatto salvato con successo.",
        walletLinked: "Contatto collegato al portafoglio con successo!",
        walletError: "L'utente non ha code associate",
        saveFirst: "Il contatto deve essere prima salvato",
      },
      wallets: {
        title: "Portafogli Contatti",
        searchPlaceholder: "Cerca contatti...",
        filterByUser: "Filtra per Utente",
        allUsers: "Tutti gli utenti",
        contact: "Contatto",
        wallet: "Portafoglio",
        user: "Utente",
        queue: "Coda",
        phone: "Telefono",
        email: "Email",
        actions: "Azioni",
        editWallet: "Modifica Portafoglio",
        selectUser: "Seleziona Utente",
        selectQueue: "Seleziona Coda",
        selectUserAndQueue: "Seleziona un utente e una coda",
        cancel: "Annulla",
        save: "Salva",
        confirmDeleteTitle: "Conferma Eliminazione",
        confirmDeleteMessage:
          "Sei sicuro di voler rimuovere questo contatto dal portafoglio?",
        deleteSuccess: "Contatto rimosso dal portafoglio con successo!",
        updateSuccess: "Portafoglio aggiornato con successo!",
      },
      queueModal: {
        title: {
          queueData: "Dati Coda",
          text: "Orari di Lavoro",
          add: "Aggiungi Coda",
          edit: "Modifica Coda",
          confirmationDelete:
            "Sei sicuro? Tutte le opzioni di integrazione verranno eliminate.",
        },
        form: {
          name: "Nome",
          color: "Colore",
          orderQueue: "Ordine Coda (Bot)",
          rotate: "Rotazione",
          timeRotate: "Tempo Rotazione",
          typeRandomMode: "Tipo Rotazione",
          selectRotationType: "Seleziona tipo rotazione",
          greetingMessage: "Messaggio di Benvenuto",
          complationMessage: "Messaggio di Fine",
          outOfHoursMessage: "Messaggio Fuori Orario",
          token: "Token",
          integrationId: "Integrazione",
          fileListId: "Lista File",
          closeTicket: "Chiudi Ticket",
          queueType: "Tipo Menu",
          message: "Messaggio Ritorno",
          queue: "Coda Trasferimento",
          integration: "Integrazione",
          file: "Lista File",
          none: "Nessuno",
          selectFile: "Seleziona un File",
          minutes: {
            singular: "minuto",
            plural: "minuti"
          }
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        bot: {
          title: "Opzioni",
          toolTipTitle: "Aggiungi opzioni per costruire un chatbot",
          toolTip:
            "Se c'è solo un'opzione, verrà scelta automaticamente e il bot risponderà con il messaggio e procederà",
          selectOption: "Seleziona un'Opzione",
          text: "Testo",
          attendent: "Agente",
          queue: "Coda",
          integration: "Integrazione",
          file: "File",
          toolTipMessageTitle:
            "Il messaggio è richiesto per procedere al livello successivo",
          toolTipMessageContent:
            "Il messaggio è richiesto per procedere al livello successivo",
          selectUser: "Seleziona un Utente",
          selectQueue: "Seleziona una Coda",
          selectIntegration: "Seleziona un'Integrazione",
          addOptions: "Aggiungi Opzioni",
          messageLabel: "Messaggio:",
        },
        validation: {
          tooShort: "Troppo Corto!",
          tooLong: "Troppo Lungo!",
          required: "Richiesto",
          mustHaveFriends: "Deve avere collegamenti",
        },
        serviceHours: {
          dayWeek: "Giorno della Settimana",
          startTimeA: "Ora Inizio - Turno A",
          endTimeA: "Ora Fine - Turno A",
          startTimeB: "Ora Inizio - Turno B",
          endTimeB: "Ora Fine - Turno B",
          monday: "Lunedì",
          tuesday: "Martedì",
          wednesday: "Mercoledì",
          thursday: "Giovedì",
          friday: "Venerdì",
          saturday: "Sabato",
          sunday: "Domenica",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Aggiungi Progetto",
          edit: "Modifica Progetto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome Progetto",
          language: "Lingua",
          jsonContent: "Contenuto JSON",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo scadenza in minuti",
          typebotKeywordFinish: "Parola chiave per terminare il ticket",
          typebotKeywordRestart: "Parola chiave per riavviare il flusso",
          typebotRestartMessage: "Messaggio al riavvio conversazione",
          typebotUnknownMessage: "Messaggio opzione non valida",
          typebotDelayMessage: "Ritardo (ms) tra messaggi",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
          test: "Testa Bot",
        },
        messages: {
          testSuccess: "Integrazione testata con successo!",
          addSuccess: "Integrazione aggiunta con successo.",
          editSuccess: "Integrazione modificata con successo.",
          errors: {
            onlyInternalAllowed: "Solo messaggi interni (note) sono permessi in questo momento."
          }
        },
        integrationTypes: {
          dialogflow: "DialogFlow",
          n8n: "N8N",
          webhook: "WebHooks",
          typebot: "Typebot",
          flowbuilder: "Flowbuilder",
        },
      },
      userModal: {
        warning: "Per importare messaggi, devi scansionare nuovamente il QR Code!",
        title: {
          add: "Aggiungi Utente",
          edit: "Modifica Utente",
          updateImage: "Aggiorna Immagine",
          removeImage: "Rimuovi Immagine",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Password",
          farewellMessage: "Messaggio di Addio",
          profile: "Profilo",
          startWork: "Ora Inizio Lavoro",
          endWork: "Ora Fine Lavoro",
          whatsapp: "Connessione Predefinita",
          allTicketEnable: "Abilitato",
          allTicketDisable: "Disabilitato",
          allTicket: "Vedi Ticket Senza Coda",
          allowGroup: "Permetti Gruppi",
          defaultMenuOpen: "Aperto",
          defaultMenuClosed: "Chiuso",
          defaultMenu: "Menu Predefinito",
          defaultTheme: "Tema Predefinito",
          defaultThemeDark: "Scuro",
          defaultThemeLight: "Chiaro",
          allHistoric: "Vedi Conversazioni Altre Code",
          allHistoricEnabled: "Abilitato",
          allHistoricDisabled: "Disabilitato",
          allUserChat: "Vedi Conversazioni Altri Utenti",
          userClosePendingTicket: "Permetti Chiusura Ticket Pendenti",
          showDashboard: "Vedi Dashboard",
          allowRealTime: "Vedi Dashboard Tempo Reale",
          allowConnections: "Permetti Azioni su Connessioni",
          showContacts: "Vedi Contatti",
          showCampaign: "Vedi Campagne",
        },
        tabs: {
          general: "Generale",
          permissions: "Permessi",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
          addImage: "Aggiungi Immagine",
          editImage: "Modifica Immagine",
        },
        success: "Utente salvato con successo.",
      },
      companyModal: {
        title: {
          add: "Aggiungi Azienda",
          edit: "Modifica Azienda",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Utenti",
          numberConections: "Connessioni",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Azienda salvata con successo.",
      },
      scheduleModal: {
        title: {
          add: "Programma Messaggio",
          edit: "Modifica Programmazione",
          message: "Messaggio",
          sendError: "Errore Invio",
        },
        subtitle: "Compila il messaggio, scegli la destinazione e definisci quando inviarlo.",
        validation: {
          messageTooShort: "Messaggio troppo corto",
          required: "Richiesto",
        },
        sections: {
          messageInfo: "Informazioni Messaggio",
          messageInfoDescription: "Scrivi il contenuto del messaggio e inserisci rapidamente le variabili disponibili.",
          destinationStatus: "Destinazione e Stato",
          destinationStatusDescription: "Definisci connessione, apertura ticket, operatore e stato finale del ticket.",
          planning: "Pianificazione / Ricorrenza",
          planningDescription: "Imposta data, ricorrenza e comportamento nei giorni festivi.",
        },
        variables: {
          title: "Variabili disponibili",
          helper: "Clicca per inserire una variabile",
        },
        form: {
          body: "Messaggio",
          contact: "Contatto",
          sendAt: "Data programmata",
          sentAt: "Data invio",
          assinar: "Invia firma",
          assinarDescription: "Aggiunge automaticamente la firma al messaggio pianificato.",
          holidayMode: "Giorni",
        },
        buttons: {
          okAdd: "Salva Programmazione",
          okEdit: "Aggiorna Programmazione",
          cancel: "Annulla",
          addSchedule: "Aggiungi Orario",
        },
        success: "Programmazione salvata con successo.",
        toasts: {
          deleted: "Multimedia eliminato con successo.",
        },
        confirmationModal: {
          deleteTitle: "Elimina multimedia",
          deleteMessage: "Sei sicuro di voler eliminare questo multimedia?",
        },
      },
      tagModal: {
        title: {
          add: "Nuova Etichetta",
          edit: "Modifica Etichetta",
          addKanban: "Nuova Corsia",
          editKanban: "Modifica Corsia",
          backToKanban: "TORNA AL KANBAN",
        },
        subtitle: "Crea etichette pulite e riconoscibili per organizzare contatti e flussi.",
        form: {
          name: "Nome",
          color: "Colore",
          timeLane: "Tempo in minuti per reindirizzare alla corsia",
          nextLaneId: "Corsia",
          greetingMessageLane: "Messaggio Benvenuto Corsia",
          rollbackLaneId: "Torna alla Corsia dopo ripresa assistenza",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Etichetta salvata con successo.",
        successKanban: "Corsia salvata con successo.",
        validation: {
          messageTooShort: "Messaggio troppo corto",
          required: "Richiesto",
        },
      },
      fileModal: {
        title: {
          add: "Aggiungi Lista File",
          edit: "Modifica Lista File",
        },
        buttons: {
          okAdd: "Salva",
          okEdit: "Modifica",
          cancel: "Annulla",
          fileOptions: "Aggiungi File",
        },
        form: {
          name: "Nome Lista File",
          message: "Dettagli Lista",
          fileOptions: "Lista File",
          extraName: "Messaggio da inviare con file",
          extraValue: "Valore Opzione",
        },
        success: "Lista file salvata con successo!",
      },
      chat: {
        noTicketMessage: "Seleziona un ticket per iniziare a chattare.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ TRASCINA E RILASCIA I FILE QUI SOTTO ⬇️",
          titleFileList: "Lista File",
        },
      },
      chatInternal: {
        new: "Nuovo gruppo",
        modal: {
          conversation: "Conversazione",
          title: "Titolo",
          filterUsers: "Filtra per Utenti",
          cancel: "Chiudi",
          save: "Salva",
        },
        modalDelete: {
          title: "Elimina Conversazione",
          message: "Questa azione non può essere annullata, confermi?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VUOI CHIUDERE TUTTI I TICKET?",
        yes: "SÌ",
        not: "NO",
        buttons: {
          newTicket: "Nuovo",
          resolveAll: "Risolvi Tutto",
          close: "Chiudi",
          new: "Nuovo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Code",
      },
      tickets: {
        search: {
          placeholder: "Cerca ticket e contatti"
        },
        inbox: {
          closedAllTickets: "Chiudere tutti i ticket?",
          closedAll: "Chiudi Tutto",
          newTicket: "Nuovo Ticket",
          yes: "SÌ",
          no: "NO",
          open: "Aperto",
          resolverd: "Risolto",
          all: "Tutto",
          searchOnMessagesTooltip: "Spunta per cercare anche nel contenuto dei messaggi (più lento)",
          ascending: "Crescente",
          descending: "Decrescente"
        },
        status: {
          open: "Aperto",
          pending: "In attesa",
          group: "Gruppo",
          closed: "Risolto",
        },
        toasts: {
          deleted: "L'assistenza che stavi gestendo è stata eliminata.",
        },
        notification: {
          message: "Messaggio da",
        },
        tabs: {
          open: { title: "Aperto" },
          closed: { title: "Risolto" },
          search: { title: "Cerca" },
        },
        search: {
          placeholder: "Cerca assistenza e messaggi",
          filterConections: "Filtra per Connessione",
          filterConectionsOptions: {
            open: "Aperto",
            closed: "Chiuso",
            pending: "Pendente",
          },
          filterUsers: "Filtra per Utenti",
          filterContacts: "Filtra per Contatti",
          ticketsPerPage: "Ticket per pagina",
        },
        buttons: {
          showAll: "Tutto",
          returnQueue: "Torna in Coda",
          scredule: "Orario",
          deleteTicket: "Elimina Ticket",
        },
        closedTicket: {
          closedMessage: "Chiudi Ticket con Messaggio di Addio",
          closedNotMessage: "Chiudi Ticket senza Messaggio di Addio",
        },
        
      },
      transferTicketModal: {
        title: "Trasferisci Ticket",
        fieldLabel: "Scrivi per cercare utenti",
        fieldQueueLabel: "Trasferisci a Coda",
        fieldQueuePlaceholder: "Seleziona una coda",
        fieldWhatsapp: "Seleziona un WhatsApp",
        noOptions: "Nessun utente trovato con questo nome",
        msgTransfer: "Note - messaggio interno, non verrà inviato al cliente",
        buttons: {
          ok: "Trasferisci",
          cancel: "Annulla",
        },
      },
      ticketsList: {
        called: "Chiamata",
        today: "Oggi",
        missedCall: "Chiamata voce/video persa il",
        pendingHeader: "In Attesa",
        assignedHeader: "In Assistenza",
        groupingHeader: "Gruppi",
        noTicketsTitle: "Niente qui!",
        noTicketsMessage:
          "Nessuna assistenza trovata con questo stato o termine di ricerca",
        noQueue: "Senza Coda",
        metaReplyWindow:
          "Hai 24 ore per rispondere dopo aver ricevuto un messaggio, secondo le politiche di Meta.",
        buttons: {
          accept: "Accetta",
          cancel: "Annulla",
          start: "Inizia",
          closed: "Chiudi",
          reopen: "Riapri",
          transfer: "Trasferisci",
          ignore: "Ignora",
          exportAsPDF: "Esporta in PDF",
          kanbanActions: "Opzioni Workflow",
        },
        acceptModal: {
          title: "Accetta Chat",
          queue: "Seleziona Settore",
        },
      },
      newTicketModal: {
        title: "Crea Ticket",
        fieldLabel: "Scrivi per cercare un contatto",
        add: "Aggiungi",
        buttons: {
          ok: "Salva",
          cancel: "Annulla",
        },
      },
      SendContactModal: {
        title: "Invia Contatto",
        fieldLabel: "Scrivi per cercare contatto",
        add: "Aggiungi",
        buttons: {
          ok: "Invia",
          cancel: "Annulla",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connessioni",
          chatsTempoReal: "Dashboard Tempo Reale",
          tickets: "Assistenze",
          quickMessages: "Risposte Rapide",
          contacts: "Contatti",
          wallets: "Portafogli",
          queues: "Code e Chatbot",
          tags: "Etichette",
          administration: "Amministrazione",
          companies: "Aziende",
          users: "Utenti",
          settings: "Impostazioni",
          files: "Liste File",
          helps: "Centro Aiuto",
          messagesAPI: "API",
          schedules: "Orari",
          campaigns: "Campagne",
          annoucements: "Annunci",
          chats: "Chat Interna",
          financeiro: "Finanziario",
          queueIntegration: "Integrazioni",
          version: "Versione",
          kanban: "Workflow",
          prompts: "Talk.AI",
          allConnections: "Gestisci Connessioni",
          reports: "Report",
          management: "Gestione",
        },
        submenuLabels: {
          flowbuilder: "Flusso Automazione",
          flowCampaign: "Flusso Campagna",
          flowConversation: "Flusso Conversazione",
        },
        tooltips: {
          expandMenu: "Espandi menu",
          collapseMenu: "Comprimi menu",
        },
        campaigns: {
          subMenus: {
            list: "Lista",
            listContacts: "Lista Contatti",
            settings: "Impostazioni",
          },
        },
        appBar: {
          user: {
            profile: "Profilo",
            logout: "Esci",
            message: "Ciao",
            messageEnd: "benvenuto in",
            active: "Attivo fino a",
            goodMorning: "Ciao,",
            myName: "il mio nome è",
            continuity: "e continuerò la tua assistenza.",
            virtualAssistant: "Assistente Virtuale",
            token: "Token non valido, contatta l'amministratore della piattaforma.",
          },
          message: {
            location: "Posizione",
            contact: "Contatto",
          },
          notRegister: "Nessun registro trovato",
          refresh: "Aggiorna",
        },
      },
      languages: {
        undefined: "Lingua",
        "pt-BR": "Portoghese",
        es: "Spagnolo",
        en: "Inglese",
        tr: "Turco",
      },
      messagesAPI: {
        title: "API",
        toSend: "DA INVIARE",
        send: "Invia",
        textMessage: {
          number: "Numero",
          body: "Messaggio",
          token: "Token Registrato",
          userId: "ID Utente/Agente",
          queueId: "ID Coda",
        },
        mediaMessage: {
          number: "Numero",
          body: "Nome File",
          media: "File",
          token: "Token Registrato",
        },
        forbiddenMessage: "Questa azienda non ha il permesso per accedere a questa pagina! Ti stiamo reindirizzando.",
        successMessage: "Messaggio inviato con successo",
        API: {
          title: "Documentazione Invio Messaggi",
          methods: {
            title: "Metodi di Invio",
            messagesText: "Messaggi di Testo",
            messagesMidia: "Messaggi Multimedia",
          },
          instructions: {
            title: "Istruzioni",
            comments: "Note Importanti",
            comments1:
              "Prima di inviare messaggi, è necessario registrare il token collegato alla connessione che invierà i messaggi. <br />Per registrare, accedi al menu 'Connessioni', clicca sul pulsante modifica nella connessione e inserisci il token nel campo appropriato.",
            comments2:
              "Il numero di invio non deve avere maschere o caratteri speciali e deve essere composto da:",
            codeCountry: "Codice Paese",
            code: "Prefisso",
            number: "Numero Telefono",
          },
          text: {
            title: "1. Messaggi di Testo",
            instructions:
              "Di seguito la lista delle informazioni richieste per inviare messaggi di testo:",
          },
          media: {
            title: "2. Messaggi Multimedia",
            instructions:
              "Di seguito la lista delle informazioni richieste per inviare messaggi multimedia:",
            endpoint: "Endpoint:",
            method: "Metodo:",
            headers: "Headers:",
            formData: "FormData:",
            file: "file",
          },
        },
      },
      notifications: {
        noTickets: "Nessuna notifica.",
        openChat: "Apri chat",
        newMessage: "Nuovo messaggio",
      },
      quickMessages: {
        title: "Risposte Rapide",
        searchPlaceholder: "Cerca...",
        noAttachment: "Nessun allegato",
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione è irreversibile! Vuoi continuare?",
        },
        buttons: {
          add: "Aggiungi",
          attach: "Allega File",
          cancel: "Annulla",
          edit: "Modifica",
        },
        toasts: {
          success: "Scorciatoia aggiunta con successo!",
          deleted: "Scorciatoia eliminata con successo!",
        },
        validation: {
          required: "Richiesto",
        },
        dialog: {
          title: "Messaggio Rapido",
          shortcode: "Scorciatoia",
          message: "Risposta",
          save: "Salva",
          cancel: "Annulla",
          general: "Generale",
          geral: "Permetti Modifica",
          add: "Aggiungi",
          edit: "Modifica",
          visao: "Permetti Visualizzazione",
          attachMedia: "Allega Multimedia",
          editMedia: "Modifica multimedia",
          removeMedia: "Rimuovi multimedia",
          newFile: "Nuovo File",
          newAudioRecorded: "Nuovo audio registrato",
          newAudio: "Nuovo Audio",
          chooseNewMediaToReplace: "Scegli nuovi media da sostituire:",
          chooseMediaOption: "Scegli un'opzione per allegare media:",
          attachFile: "Allega File",
          recordAudio: "Registra Audio",
          cancelEdit: "Annulla Modifica",
          type: "Tipo",
          value: "Valore",
          status: "Stato",
          language: "Lingua",
          category: "Categoria",
          metaID: "Meta ID",
        },
        table: {
          shortcode: "Scorciatoia",
          message: "Messaggio",
          actions: "Azioni",
          mediaName: "Nome File",
          status: "Stato",
          media: "Multimedia",
        },
      },
      contactLists: {
        title: "Liste Contatti",
        table: {
          name: "Nome",
          contacts: "Contatti",
          actions: "Azioni",
        },
        buttons: {
          add: "Nuova Lista",
          downloadExample: "Scarica Foglio Esempio",
          viewContacts: "Vedi Contatti",
          edit: "Modifica",
          delete: "Elimina",
          selectAll: "Seleziona tutti",
          deselectAll: "Deseleziona tutti",
        },
        modal: {
          selectContacts: "Seleziona contatti",
        },
        emptySelection: "Nessun contatto trovato.",
        dialog: {
          name: "Nome",
          company: "Azienda",
          okEdit: "Modifica",
          okAdd: "Aggiungi",
          add: "Aggiungi",
          edit: "Modifica",
          cancel: "Annulla",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        toasts: {
          deleted: "Registro eliminato con successo.",
        },
        summary: {
          totalLists: "Totale liste",
          totalContacts: "Totale contatti",
        },
        emptyState: {
          title: "Nessuna lista trovata",
          description: "Crea la tua prima lista di contatti.",
        },
      },
      contactListItems: {
        title: "Contatti",
        searchPlaceholder: "Cerca",
        buttons: {
          add: "Nuovo",
          lists: "Liste",
          import: "Importa",
          importFromContacts: "Importa da contatti",
        },
        status: {
          valid: "WhatsApp valido",
          invalid: "WhatsApp non valido",
        },
        summary: {
          total: "Totale",
          valid: "Validi",
          invalid: "Non validi",
        },
        emptyState: {
          title: "Nessun contatto trovato",
          description: "Aggiungi o importa contatti in questa lista.",
        },
        dialog: {
          name: "Nome",
          number: "Numero",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Modifica",
          okAdd: "Aggiungi",
          add: "Aggiungi",
          edit: "Modifica",
          cancel: "Annulla",
        },
        table: {
          name: "Nome",
          number: "Numero",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Azioni",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata.",
          importMessage:
            "Vuoi importare i contatti da questo foglio di calcolo?",
          importTitlte: "Importa",
          downloadExample: "Scarica il foglio di esempio.",
        },
        toasts: {
          deleted: "Registro eliminato con successo.",
        },
      },
      kanban: {
        title: "Workflow",
        searchPlaceholder: "Cerca",
        subMenus: {
          list: "Bacheca",
          tags: "Corsie",
        },
        sortOrder: "Ordina per",
        ticketNumber: "Numero Ticket",
        lastMessage: "Ultimo Messaggio",
        valueDesc: "Valore (dal più alto)",
        startDate: "Data inizio",
        endDate: "Data fine",
        search: "Cerca",
        addColumns: "+ Aggiungi colonne",
        ticketPrefix: "Ticket #",
        assignValue: "Assegna Valore",
        value: "Valore",
        remove: "Rimuovi",
        viewTicket: "Vedi Ticket",
        editValue: "Modifica",
        saveValue: "Salva",
        cancel: "Annulla",
        opportunityValue: "Valore Opportunità",
        total: "Totale",
        ticketUpdatedSuccess: "Etichetta Ticket aggiornata con successo!",
        ticketRemovedSuccess: "Etichetta Ticket rimossa!",
      },
      campaigns: {
        title: "Campagne",
        searchPlaceholder: "Cerca",
        dialog: {
          form: {
            whatsapp: "Connessione",
            openTicket: "Apri Ticket",
            enabledOpenTicket: "Abilitato",
            disabledOpenTicket: "Disabilitato",
            statusTicket: "Stato Ticket",
            closedTicketStatus: "Chiuso",
            openTicketStatus: "Aperto",
          },
        },
        subMenus: {
          list: "Elenco",
          listContacts: "Lista Contatti",
          settings: "Impostazioni",
        },
        settings: {
          randomInterval: "Intervallo Casuale Invio",
          noBreak: "Nessun Intervallo",
          intervalGapAfter: "Intervallo più lungo dopo",
          undefined: "Non definito",
          messages: "messaggi",
          laggerTriggerRange: "Intervallo Invio Maggiore",
          addVar: "Aggiungi Variabile",
          save: "Salva",
          close: "Chiudi",
          add: "Aggiungi",
          shortcut: "Scorciatoia",
          content: "Contenuto",
        },
        buttons: {
          add: "Nuova Campagna",
          contactLists: "Liste Contatti",
        },
        table: {
          name: "Nome",
          whatsapp: "Connessione",
          contactList: "Lista Contatti",
          option: "Nessuno",
          disabled: "Disabilitato",
          enabled: "Abilitato",
          status: "Stato",
          scheduledAt: "Programmato",
          completedAt: "Completato",
          confirmation: "Conferma",
          actions: "Azioni",
          recurrence: "Ricorrenza",
          nextExecution: "Prossima Esecuzione",
        },
        toasts: {
          deleted: "Campagna eliminata con successo!",
          cancel: "Campagna annullata con successo!",
          restart: "Campagna riavviata con successo!",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        filters: {
          statusFilter: "Filtra per Stato",
          recurrenceFilter: "Filtra per Ricorrenza",
          all: "Tutto",
          allRecurrence: "Tutto",
          inactive: "Inattivo",
          scheduled: "Programmato",
          inProgress: "In Corso",
          canceled: "Annullato",
          finished: "Finalizzato",
          recurring: "Ricorrente",
          single: "Singolo",
        },
        quickActions: {
          title: "Azioni rapide",
        },
        legend: {
          show: "Mostra legenda",
          hide: "Nascondi legenda",
        },
        summary: {
          total: "Totale",
          scheduled: "Programmate",
          inProgress: "In corso",
          finished: "Finalizzate",
          canceled: "Annullate",
          inactive: "Inattive",
        },
        emptyState: {
          title: "Nessuna campagna trovata",
          description: "Prova a modificare i filtri o crea una nuova campagna.",
        },
        recurrence: {
          title: "Ricorrenza",
          type: {
            daily: "Giornaliero",
            weekly: "Settimanale",
            biweekly: "Quindicinale",
            monthly: "Mensile",
            yearly: "Annuale",
          },
          nextExecution: "Prossima Esecuzione",
          executions: "esecuzioni",
          single: "Singolo",
          finished: "Ricorrenza terminata",
          stopTitle: "Ferma Ricorrenza",
          stopMessage: "Sei sicuro di voler fermare la ricorrenza di questa campagna? La campagna corrente continuerà, ma non ci saranno più esecuzioni future.",
          stopSuccess: "Ricorrenza fermata con successo!",
        },
        status: {
          inactive: "Inattivo",
          scheduled: "Programmato",
          inProgress: "In Corso",
          canceled: "Annullato",
          finished: "Finalizzato",
        },
        tooltips: {
          recurringCampaign: "Campagna Ricorrente",
          stop: "Ferma Campagna",
          restart: "Riavvia Campagna",
          stopRecurrence: "Ferma Ricorrenza",
          report: "Report",
          edit: "Modifica",
          delete: "Elimina",
        },
        noSchedule: "Nessun orario",
        notCompleted: "Non completato",
        listRemoved: "Lista rimossa",
        whatsappRemoved: "WhatsApp rimosso",
        notDefined: "Non definito",
        notDefinedFemale: "Non definita",
        enabled: "Abilitato",
        disabled: "Disabilitato",
        tag: "Etichetta",
        permissionError: "Questa azienda non ha il permesso per accedere a questa pagina! Ti stiamo reindirizzando.",
        dialog: {
          new: "Nuova Campagna",
          update: "Modifica Campagna",
          readonly: "Sola Lettura",
          help: "Usa variabili come {name}, {number}, {email}, o definisci variabili personalizzate.",
          form: {
            name: "Nome",
            message1: "Messaggio 1",
            message2: "Messaggio 2",
            message3: "Messaggio 3",
            message4: "Messaggio 4",
            message5: "Messaggio 5",
            confirmationMessage1: "Messaggio Conferma 1",
            confirmationMessage2: "Messaggio Conferma 2",
            confirmationMessage3: "Messaggio Conferma 3",
            confirmationMessage4: "Messaggio Conferma 4",
            confirmationMessage5: "Messaggio Conferma 5",
            messagePlaceholder: "Contenuto del messaggio",
            whatsapp: "Connessione",
            status: "Stato",
            scheduledAt: "Orario",
            confirmation: "Conferma",
            contactList: "Lista Contatti",
            tagList: "Etichette",
            statusTicket: "Stato Ticket",
            openTicketStatus: "Aperto",
            pendingTicketStatus: "In Attesa",
            closedTicketStatus: "Chiuso",
            enabledOpenTicket: "Abilitato",
            disabledOpenTicket: "Disabilitato",
            openTicket: "Apri Ticket",
          },
          buttons: {
            add: "Aggiungi",
            edit: "Aggiorna",
            okadd: "Ok",
            cancel: "Annulla Invio",
            restart: "Riavvia Invio",
            close: "Chiudi",
            attach: "Allega File",
          },
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        toasts: {
          success: "Operazione completata con successo.",
          cancel: "Campagna annullata.",
          restart: "Campagna riavviata.",
          deleted: "Registro eliminato con successo.",
        },
      },
      campaignReport: {
        title: "Report Campagna",
        inactive: "Inattivo",
        scheduled: "Programmato",
        process: "In Corso",
        cancelled: "Annullato",
        finished: "Completato",
        campaign: "Campagna",
        validContacts: "Contatti Validi",
        confirmationsRequested: "Conferme Richieste",
        confirmations: "Conferme",
        deliver: "Consegnato",
        connection: "Connessione",
        contactLists: "Lista Contatti",
        schedule: "Orario",
        conclusion: "Conclusione",
      },
      announcements: {
        title: "Annunci",
        searchPlaceholder: "Cerca",
        active: "Attivo",
        inactive: "Inattivo",
        buttons: {
          add: "Nuovo Annuncio",
          contactLists: "Liste Annunci",
        },
        table: {
          priority: "Priorità",
          title: "Titolo",
          text: "Testo",
          mediaName: "File",
          status: "Stato",
          actions: "Azioni",
        },
        dialog: {
          edit: "Modifica Annuncio",
          add: "Nuovo Annuncio",
          update: "Modifica Annuncio",
          readonly: "Sola Lettura",
          form: {
            priority: "Priorità",
            title: "Titolo",
            text: "Testo",
            mediaPath: "File",
            status: "Stato",
            high: "Alto",
            medium: "Medio",
            low: "Basso",
            active: "Attivo",
            inactive: "Inattivo",
          },
          buttons: {
            add: "Aggiungi",
            edit: "Aggiorna",
            okadd: "Ok",
            cancel: "Annulla",
            close: "Chiudi",
            attach: "Allega File",
          },
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        toasts: {
          success: "Operazione completata con successo.",
          deleted: "Registro eliminato con successo.",
        },
      },
      campaignsConfig: {
        title: "Configurazione Campagne",
        intervals: "Intervalli",
        randomInterval: "Intervallo Casuale Invio",
        noBreak: "Nessun Intervallo",
        intervalGapAfter: "Intervallo più lungo dopo",
        undefined: "Non definito",
        messages: "messaggi",
        laggerTriggerRange: "Intervallo Invio Maggiore",
        save: "Salva",
        seconds: "secondi",
        forbiddenMessage: "Questa azienda non ha il permesso per accedere a questa pagina! Ti stiamo reindirizzando.",
        confirmDelete: "Sei sicuro di voler eliminare questa variabile?",
        deleteMessage: "Questa azione non può essere annullata.",
      },
      queues: {
        title: "Code e Chatbot",
        table: {
          name: "Nome",
          color: "Colore",
          greeting: "Messaggio di Benvenuto",
          orderQueue: "Ordine Coda (Bot)",
          actions: "Azioni",
          ID: "ID",
        },
        buttons: {
          add: "Aggiungi Coda",
        },
        toasts: {
          success: "Coda salvata con successo.",
          deleted: "Coda eliminata con successo.",
          clickSave: "Clicca su salva per registrare le modifiche",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Sei sicuro? Questa azione non può essere annullata! Le assistenze di questa coda esisteranno ancora ma non saranno più assegnate a una coda.",
        },
      },
      queue: {
        queueData: "Dati Coda",
      },
      queueSelect: {
        inputLabel: "Code",
        inputLabelRO: "Code Sola Lettura",
        withoutQueue: "Senza Coda",
      },
      reports: {
        title: "Report Assistenza",
        startDate: "Data Inizio",
        endDate: "Data Fine",
        table: {
          id: "Ticket",
          user: "Utente",
          dateOpen: "Data Apertura",
          dateClose: "Data Chiusura",
          NPS: "NPS",
          status: "Stato",
          whatsapp: "Connessione",
          queue: "Coda",
          actions: "Azioni",
          lastMessage: "Ultimo Messaggio",
          contact: "Cliente",
          supportTime: "Tempo Assistenza",
          valorVenda: "Valore Vendita",
          motivoNaoVenda: "Motivo No Vendita",
          finalizadoComVenda: "Chiuso con Vendita",
          wallet: "Portafoglio",
          ticketsPerPage: "Ticket per pagina",
        },
        buttons: {
          filter: "Applica Filtro",
          onlyRated: "Solo Valutati",
          exportExcel: "Esporta in Excel",
        },
        searchPlaceholder: "Cerca...",
        tooltips: {
          logsTicket: "Log Ticket",
          accessTicket: "Accedi Ticket",
          exportExcel: "Esporta in Excel",
        },
        exportExcel: {
          title: "Report Assistenza",
          startDate: "Data Inizio",
          endDate: "Data Fine",
          notInformed: "Non informato",
          columns: {
            id: "ID",
            connection: "Connessione",
            contact: "Contatto",
            user: "Utente",
            queue: "Coda",
            status: "Stato",
            lastMessage: "Ultimo Messaggio",
            openDate: "Data Apertura",
            openTime: "Ora Apertura",
            closeDate: "Data Chiusura",
            closeTime: "Ora Chiusura",
            supportTime: "Tempo Supporto",
            nps: "NPS",
            valorVenda: "Valore Vendita",
            motivoNaoVenda: "Motivo No Vendita",
            finalizadoComVenda: "Chiuso con Vendita",
          },
        },
        finalizadoComVenda: {
          sim: "Sì",
          nao: "No",
        },
      },
      queueIntegration: {
        title: "Integrazioni",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome Progetto",
          language: "Lingua",
          lastUpdate: "Ultimo Aggiornamento",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi Progetto",
        },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Sei sicuro? Questa azione non può essere annullata e verrà rimossa da code e connessioni collegate.",
        },
        toasts: {
          deleted: "Integrazione eliminata con successo!",
          permissionError: "Questa azienda non ha il permesso per accedere a questa pagina! Ti stiamo reindirizzando.",
        },
        validation: {
          tooShort: "Troppo Corto!",
          tooLong: "Troppo Lungo!",
          required: "Richiesto",
        },
        languages: {
          portuguese: "Portoghese",
          english: "Inglese",
          spanish: "Spagnolo",
        },
      },
      users: {
        title: "Utenti",
        table: {
          status: "Stato",
          name: "Nome",
          email: "Email",
          profile: "Profilo",
          startWork: "Ora Inizio Lavoro",
          endWork: "Ora Fine Lavoro",
          actions: "Azioni",
          ID: "ID",
          avatar: "Avatar",
        },
        buttons: {
          add: "Aggiungi Utente",
          generateExistingChats: "Genera Chat Esistenti",
        },
        summary: {
          total: "Totale utenti",
        },
        emptyState: {
          title: "Nessun utente trovato",
          description: "Aggiungi il primo utente per iniziare.",
        },
        toasts: {
          deleted: "Utente eliminato con successo.",
          chatCreated: "Chat creata con successo!",
          chatsGenerated: "Chat generate con successo!",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Tutti i dati dell'utente andranno persi. I ticket aperti per questo utente verranno spostati in coda.",
        },
      },
      compaies: {
        title: "Aziende",
        table: {
          ID: "ID",
          status: "Attivo",
          name: "Nome",
          email: "Email",
          password: "Password",
          phone: "Telefono",
          plan: "Piano",
          active: "Attivo",
          numberAttendants: "Agenti",
          numberConections: "Connessioni",
          value: "Valore",
          namePlan: "Nome Piano",
          numberQueues: "Code",
          useCampaigns: "Campagne",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Chat Interna",
          useSchedules: "Programmazione",
          createdAt: "Creato Il",
          dueDate: "Data Scadenza",
          lastLogin: "Ultimo Login",
          folderSize: "Dimensione Cartella",
          totalFiles: "Totale File",
          lastUpdate: "Ultimo aggiornamento",
          actions: "Azioni",
          money: "€",
          yes: "Sì",
          no: "No",
          document: "P.IVA/CF",
          recurrence: "Ricorrenza",
          monthly: "Mensile",
          bimonthly: "Bimestrale",
          quarterly: "Trimestrale",
          semester: "Semestrale",
          yearly: "Annuale",
          clear: "Pulisci",
          delete: "Elimina",
          user: "Utente",
          save: "Salva",
          generateInvoice: "Genera Fattura",
          currency: "Valuta",
          noCompanies: "Nessuna azienda trovata."
        },
        buttons: {
          add: "Aggiungi Azienda",
        },
        toasts: {
          deleted: "Azienda eliminata con successo.",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Tutti i dati dell'azienda andranno persi. I ticket aperti per gli utenti in questa azienda verranno spostati in coda.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Utenti",
          connections: "Connessioni",
          currency: "Valuta",
          campaigns: "Campagne",
          schedules: "Orari",
          enabled: "Abilitato",
          disabled: "Disabilitato",
          clear: "Annulla",
          delete: "Elimina",
          save: "Salva",
          yes: "Sì",
          no: "No",
          money: "€",
          public: "Pubblico",
          trial: "Prova",
          trialDays: "Giorni di Prova",
        },
      },
      helps: {
        title: "Centro Aiuto",
        settings: {
          codeVideo: "Codice Video",
          description: "Descrizione",
          filterUsers: "Cerca utenti da aggiungere",
          clear: "Pulisci",
          delete: "Elimina",
          save: "Salva",
        },
      },
      schedules: {
        title: "Orari",
        date: "Data",
        time: "Ora",
        event: "Evento",
        allDay: "Tutto il Giorno",
        week: "Settimana",
        work_week: "Settimana Lavorativa",
        day: "Giorno",
        month: "Mese",
        previous: "Precedente",
        next: "Successivo",
        yesterday: "Ieri",
        tomorrow: "Domani",
        today: "Oggi",
        agenda: "Agenda",
        noEventsInRange: "Nessun evento in questo intervallo.",
        errors: {
          noPermission: "Questa azienda non ha il permesso per accedere a questa pagina! Ti stiamo reindirizzando.",
        },
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questo Orario?",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        table: {
          contact: "Contatto",
          body: "Messaggio",
          sendAt: "Data Programmata",
          sentAt: "Data Invio",
          status: "Stato",
          actions: "Azioni",
        },
        buttons: {
          add: "Nuovo Orario",
        },
        toasts: {
          deleted: "Orario eliminato con successo.",
        },
      },
      tags: {
        title: "Etichette",
        addColumns: "+ AGGIUNGI COLONNE",
        search: "CERCA",
        seeTicket: "VEDI TICKET",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questa Etichetta?",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Workflow",
          color: "Colore",
          tickets: "Registri Etichetta",
          contacts: "Contatti",
          actions: "Azioni",
        },
        buttons: {
          add: "Nuova Etichetta",
        },
        summary: {
          total: "Totale",
          contacts: "Contatti",
        },
        emptyState: {
          title: "Nessuna etichetta trovata",
          description: "Nessuna etichetta trovata. Inizia a organizzare i tuoi contatti creando la prima!",
        },
        toasts: {
          deleted: "Etichetta eliminata con successo.",
        },
        contactModal: {
          title: "Contatti",
          tableHeaders: {
            id: "ID",
            name: "Nome",
            number: "Numero",
            actions: "Azioni",
          },
        },
      },
      tagsKanban: {
        title: "Corsie",
        laneDefault: "Aperto",
        backToKanban: "TORNA AL KANBAN",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questa Corsia?",
          deleteMessage: "Questa azione non può essere annullata.",
        },
        table: {
          name: "Nome",
          color: "Colore",
          tickets: "Ticket",
          actions: "Azioni",
        },
        buttons: {
          add: "Nuova Corsia",
        },
        toasts: {
          deleted: "Corsia eliminata con successo.",
        },
      },
      files: {
        title: "Liste File",
        table: {
          name: "Nome",
          contacts: "Contatti",
          actions: "Azione",
        },
        toasts: {
          deleted: "Lista file eliminata con successo!",
          deletedAll: "Tutte le liste file sono state eliminate con successo!",
        },
        buttons: {
          add: "Aggiungi",
          deleteAll: "Elimina Tutto",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteAllTitle: "Elimina Tutto",
          deleteMessage: "Sei sicuro di voler eliminare questa lista?",
          deleteAllMessage: "Sei sicuro di voler eliminare tutte le liste?",
        },
      },
      settings: {
        success: "Configurazione salvata con successo.",
        title: "Configurazione",
        finalization: {
          title: "Finalizzazione dell'Assistenza",
          generalConfig: "Configurazioni Generali",
          askSaleValue: "Indicare il valore della vendita alla chiusura dell'assistenza",
          askSaleValueHelper: "Quando abilitato, il campo valore della vendita apparirà nel modal di finalizzazione",
          reasonsTitle: "Motivi di Finalizzazione",
          addReason: "Aggiungi Motivo",
          editReason: "Modifica Motivo",
          reasonName: "Nome del Motivo",
          reasonDescription: "Descrizione (opzionale)",
          cancel: "Annulla",
          saving: "Salvataggio...",
          update: "Aggiorna",
          add: "Aggiungi",
          empty: "Nessun motivo registrato. Clicca su \"Aggiungi Motivo\" per iniziare.",
          table: {
            name: "Nome",
            description: "Descrizione",
          filterUsers: "Cerca utenti da aggiungere",
            actions: "Azioni",
            noDescription: "Senza descrizione"
          },
          toasts: {
            updateSuccess: "Configurazione aggiornata con successo!",
            updateError: "Errore durante l'aggiornamento della configurazione",
            deleteError: "Errore durante l'eliminazione del motivo"
          }
        },
        tabs: {
          options: "Opzioni",
          plans: "Piani",
          helps: "Aiuto",
          companies: "Aziende",
        },
        settings: {
          userCreation: {
            name: "Creazione Utente",
            options: {
              enabled: "Abilitato",
              disabled: "Disabilitato",
            },
          },
          tabs: {
            options: "Opzioni",
            schedules: "Orari",
            plans: "Piani",
            help: "Aiuto",
          },
          options: {
            disabled: "Disabilitato",
            enabled: "Abilitato",
            updating: "Aggiornamento in corso...",
            creationCompanyUser: "Creazione Azienda/Utente",
            evaluations: "Valutazioni",
            officeScheduling: "Orari Ufficio",
            queueManagement: "Gestione Code",
            companyManagement: "Gestione Azienda",
            connectionManagement: "Gestione Connessioni",
            sendGreetingAccepted: "Invia Saluto Accettazione Ticket",
            sendMsgTransfTicket:
              "Invia Messaggio Trasferimento tra Dipartimenti/Agenti",
            checkMsgIsGroup: "Ignora Messaggi Gruppo",
            chatBotType: "Tipo Bot",
            userRandom: "Selezione Casuale Agente",
            buttons: "Pulsanti",
            acceptCallWhatsapp: "Notificare che la chiamata WhatsApp non è accettata?",
            sendSignMessage: "Permetti all'agente di scegliere invio Firma",
            sendGreetingMessageOneQueues:
              "Invia Saluto quando esiste una sola coda",
            sendQueuePosition: "Invia Messaggio Posizione Coda",
            sendFarewellWaitingTicket: "Invia Messaggio Addio in Attesa",
            acceptAudioMessageContact:
              "Accetta Messaggi Audio da Tutti i Contatti?",
            enableLGPD: "Abilita Elaborazione LGPD",
            requiredTag: "Etichetta Richiesta per Chiudere Ticket",
            closeTicketOnTransfer:
              "Chiudi Ticket al Trasferimento ad Altra Coda",
            DirectTicketsToWallets: "Sposta Automaticamente Cliente nel Portafoglio",
            showNotificationPending: "Mostra Notifica per Ticket Pendenti",
            copyContactPrefix: "Prefisso Copia Contatto",
            copyContactPrefixPlaceholder: "Es: COPY_",
            schedules: "Orari",
            configurationPix: "Configurazione Pix Efí (GerenciaNet)",
            mercadoPago: "Mercado Pago",
            stripe: "Stripe",
            asaas: "ASAAS",
            clientId: "Client ID",
            clientSecret: "Client Secret",
            pixKey: "Chiave PIX",
            accessToken: "Access Token",
            stripePrivateKey: "Chiave Privata Stripe",
            asaasToken: "Token Asaas",
            configurationCopyPrefix: "Configurazione Prefisso Copia Contatto",
            successOperation: "Operazione aggiornata con successo.",
            text: "Testo",
            finalizationAttendance: "Finalizzazione Servizio"
          },
          customMessages: {
            sendQueuePositionMessage: "Messaggio Posizione Coda",
            AcceptCallWhatsappMessage: "Messaggio Informazione Chiamata Non Accettata",
            greetingAcceptedMessage: "Messaggio Saluto Accettazione Ticket",
            transferMessage:
              "Messaggio Trasferimento - ${queue.name} = coda destinazione",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Messaggio Benvenuto (LGPD)",
            linkLGPD: "Link Privacy Policy",
            obfuscateMessageDelete: "Offusca Messaggio Eliminato",
            alwaysConsent: "Richiedi Sempre Consenso",
            obfuscatePhoneUser: "Offusca Numero Telefono Utente",
            enabled: "Abilitato",
            disabled: "Disabilitato",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assegnato a:",
          dialogRatingTitle:
            "Vuoi lasciare una valutazione del servizio per il cliente?",
          dialogClosingTitle: "Chiusura servizio con il cliente!",
          dialogRatingCancel: "Risolvi CON Messaggio Addio",
          dialogRatingSuccess: "Risolvi e Invia Valutazione",
          dialogRatingWithoutFarewellMsg: "Risolvi SENZA Messaggio Addio",
          ratingTitle: "Scegli un menu di valutazione",
          notMessage: "Nessun messaggio selezionato",
          amount: "Valore Prospezione",
          buttons: {
            return: "Indietro",
            resolve: "Risolvi",
            reopen: "Riapri",
            accept: "Accetta",
            rating: "Invia Valutazione",
            enableIntegration: "Abilita Integrazione",
            disableIntegration: "Disabilita Integrazione",
            logTicket: "Log Ticket",
            requiredTag: "Devi assegnare un'etichetta prima di chiudere il ticket.",
            greetingAcceptedMessage:
              "Devi configurare un messaggio di saluto all'accettazione del ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Scrivi un messaggio o premi / per risposte rapide",
        placeholderOpen: "Scrivi un messaggio o premi / per risposte rapide",
        placeholderPending:
          "Messaggio interno (ticket in attesa di accettazione)...",
        placeholderClosed: "Riapri o accetta questo ticket per inviare un messaggio.",
        signMessage: "Firma",
        privateMessage: "Messaggio Privato",
        internalMessageLabel: "Messaggio Interno",
      },
      contactDrawer: {
        header: "Dettagli Contatto",
        buttons: {
          edit: "Modifica Contatto",
          block: "Blocca",
          unblock: "Sblocca",
        },
        extraInfo: "Informazioni Aggiuntive",
      },
      messageVariablesPicker: {
        label: "Variabili Disponibili",
        vars: {
          contactFirstName: "Nome",
          contactName: "Nome Completo",
          user: "Agente",
          greeting: "Saluto",
          protocolNumber: "Numero Protocollo",
          date: "Data",
          hour: "Ora",
          ticket_id: "Numero Ticket",
          queue: "Settore",
          connection: "Connessione",
        },
      },
      ticketOptionsMenu: {
        schedule: "Orario",
        delete: "Elimina",
        transfer: "Trasferisci",
        registerAppointment: "Note Contatto",
        resolveWithNoFarewell: "Risolvi senza Addio",
        acceptAudioMessage: "Accettare messaggi audio dal contatto?",
        appointmentsModal: {
          title: "Note Ticket",
          textarea: "Nota",
          placeholder: "Inserisci qui le informazioni che vuoi registrare",
        },
        confirmationModal: {
          title: "Elimina ticket del contatto",
          titleFrom: "del contatto",
          message:
            "Attenzione! Tutti i messaggi relativi a questo ticket andranno persi.",
        },
        buttons: {
          delete: "Elimina",
          cancel: "Annulla",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Abilita/Disabilita Firma",
          privateMessage: "Abilita/Disabilita Messaggio Privato",
          meet: "Invia link videoconferenza",
        },
        type: {
          imageVideo: "Foto e Video",
          cam: "Fotocamera",
          contact: "Contatto",
          meet: "Videochiamata",
          template: "Template Meta",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Annulla",
        },
      },
      messageOptionsMenu: {
        delete: "Elimina",
        reply: "Rispondi",
        edit: "Modifica",
        forward: "Inoltra",
        toForward: "Inoltra",
        talkTo: "Parla Con",
        confirmationModal: {
          title: "Elimina messaggio?",
          message: "Questa azione non può essere annullata.",
        },
      },
      invoices: {
        table: {
          invoices: "Fatture",
          details: "Dettagli",
          users: "Utenti",
          connections: "Connessioni",
          queue: "Code",
          value: "Valore",
          expirationDate: "Data Scadenza",
          action: "Azione",
        },
      },
      backendErrors: {
        ERR_USER_EMAIL_EXISTS: "Esiste già un utente con questa email.",
        ERR_NO_OTHER_WHATSAPP:
          "Deve esserci almeno una connessione WhatsApp predefinita.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nessun WhatsApp predefinito trovato. Controlla la pagina connessioni.",
        ERR_WAPP_NOT_INITIALIZED:
          "Questa sessione WhatsApp non è inizializzata. Controlla la pagina connessioni.",
        ERR_WAPP_CHECK_CONTACT:
          "Impossibile verificare il contatto WhatsApp. Controlla la pagina connessioni.",
        ERR_WAPP_INVALID_CONTACT: "Questo non è un numero WhatsApp valido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Impossibile scaricare media da WhatsApp. Controlla la pagina connessioni.",
        ERR_INVALID_CREDENTIALS: "Errore autenticazione. Riprova.",
        ERR_SENDING_WAPP_MSG:
          "Errore invio messaggio WhatsApp. Controlla la pagina connessioni.",
        ERR_DELETE_WAPP_MSG: "Impossibile eliminare messaggio WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "Esiste già un ticket aperto per questo contatto.",
        ERR_SESSION_EXPIRED: "Sessione scaduta. Effettua il login.",
        ERR_USER_CREATION_DISABLED:
          "L'amministratore ha disabilitato la creazione di utenti.",
        ERR_NO_PERMISSION: "Non hai il permesso per accedere a questa risorsa.",
        ERR_DUPLICATED_CONTACT: "Esiste già un contatto con questo numero.",
        ERR_NO_SETTING_FOUND: "Nessuna configurazione trovata con questo ID.",
        ERR_NO_CONTACT_FOUND: "Nessun contatto trovato con questo ID.",
        ERR_NO_TICKET_FOUND: "Nessun ticket trovato con questo ID.",
        ERR_NO_USER_FOUND: "Nessun utente trovato con questo ID.",
        ERR_NO_WAPP_FOUND: "Nessun WhatsApp trovato con questo ID.",
        ERR_CREATING_MESSAGE: "Errore creazione messaggio nel database.",
        ERR_CREATING_TICKET: "Errore creazione ticket nel database.",
        ERR_FETCH_WAPP_MSG:
          "Errore recupero messaggio da WhatsApp, probabilmente troppo vecchio.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Questo colore è già in uso, scegline un altro.",
        ERR_WAPP_GREETING_REQUIRED:
          "Il messaggio di saluto è richiesto se c'è più di una coda.",
        ERR_OUT_OF_HOURS: "Fuori Orario di Lavoro!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Metodo:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrato) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "393331234567"',
        fieldBody: '"body": "Messaggio"',
        fieldUserId: '"userId": ID Utente o ""',
        fieldQueueId: '"queueId": ID Coda o ""',
        fieldSendSignature: '"sendSignature": Firma messaggio - true/false',
        fieldCloseTicket: '"closeTicket": Chiudi ticket - true/false',
        singMessage: "Firma messaggio - true/false",
        closeTicket: "Chiudi ticket - true/false",
        testSend: "Invio di Prova",
      },
      recurrenceSection: {
        title: "Ricorrenza",
        description:
          "Usa questi campi solo se vuoi ripetere l'invio del messaggio nel tempo.",
        labelInterval: "Intervallo",
        intervalFilterValue: "Valore",
        sendAsManyTimes: "Invia tante volte",
        shipNormallyOnNonbusinessDays: "Invia anche nei giorni festivi",
        sendOneBusinessDayBefore: "Invia un giorno lavorativo prima",
        sendOneBusinessDayLater: "Invia un giorno lavorativo dopo",
        options: {
          days: "Giorni",
          weeks: "Settimane",
          months: "Mesi",
          minutes: "Minuti",
        },
        servicePanel: {
          allowRealTime: "Pannello Servizio",
        },
      },
      servicePanel: {
        allowRealTime: "Pannello Servizio",
      },
      financial: {
        title: "Fatture",
        invoices: "Fatture",
        details: "Dettagli",
        users: "Utenti",
        connections: "Connessioni",
        queues: "Code",
        value: "Valore",
        expirationDate: "Data Scadenza",
        status: "Stato",
        action: "Azione",
        pay: "PAGA",
        paid: "PAGATO",
        expired: "Scaduto",
        open: "Aperto",
        attentionMessage: "Attenzione:",
        expiredWarning: "Il tuo abbonamento è scaduto. Contatta il supporto per regolarizzare la tua situazione.",
        summary: {
          total: "Totale",
          open: "Aperte",
          paid: "Pagate",
          expired: "Scadute",
        },
        emptyState: {
          title: "Nessuna fattura trovata",
          description: "Non ci sono fatture da mostrare.",
        },
        yes: "Sì",
        no: "No",
      },
      statusFilter: {
        statusFilter: "Filtra per Stato",
      },
      momentsUser: {
        services: "Servizi:",
        pending: "Pendente",
        noqueue: "SENZA CODA",
        accessTicket: "Accedi Ticket",
      },
      campaignsPhrase: {
        campaignsFlow: "Flusso Campagne",
        campaigns: "Campagna",
        name: "Nome",
        status: "Stato",
        newCampaignWithFlowByPhrase: "Nuova campagna con flusso per frase",
        editCampaignWithFlowByPhrase: "Modifica campagna con flusso per frase",
        phraseTriggerName: "Nome attivatore frase",
        chooseAStream: "Scegli un flusso",
        whichPhraseTriggersTheFlow: "Quale frase attiva il flusso?",
        selectAConnection: "Seleziona una Connessione",
        status: "Stato",
        cancel: "ANNULLA",
        createCampaign: "CREA CAMPAGNA",
        saveCampaign: "Salva Campagna",
        title: "Campagne Flusso",
        newCampaign: "Nuova Campagna",
        editCampaign: "Modifica campagna",
        deleteCampaign: "Elimina campagna",
        deleteSuccess: "Campagna eliminata con successo",
        noConnection: "Nessuna connessione",
        connections: "Connessioni",
        active: "Attivo",
        disabled: "Disabilitato",
        nameNotDefined: "Nome non definito",
        phrasesConfigured: "frase(i) configurata(e)",
        noCampaignsFound: "Nessuna campagna trovata",
        clickToCreateFirst: "Clicca su 'Nuova Campagna' per creare la tua prima campagna di flusso",
        moreConnections: "Più",
        connection: "connessione(i)",
        actions: "Azioni",
      },
      chatList: {
        noMessages: "Nessun messaggio",
        admin: "Amministratore",
        member: "Membro",
        searchChat: "Cerca chat...",
        createNewChat: "Crea nuova chat",
        searchUser: "Cerca utente...",
        noUserFound: "Utente non trovato",
        noUserAvailable: "Utente non disponibile",
        cancel: "Annulla",
        details: "Dettagli",
        deleteChat: "Elimina Chat",
        deleteChatConfirm: "Questa azione non può essere annullata, confermi?",
        detailsTitle: "Dettagli",
        edit: "Modifica",
        delete: "Elimina",
        now: "ora",
        minutesAgo: "{{count}}m fa",
        hoursAgo: "{{count}}h fa",
        audio: "[Audio]",
        image: "[Immagine]",
        video: "[Video]",
        file: "[File]",
        group: "Gruppo",
        user: "Utente",
        errorLoadingUsers: "Errore caricamento utenti",
        chatAlreadyExists: "Chat con questo utente già esistente!",
        chatCreatedSuccess: "Chat creata con successo!",
        errorCreatingChat: "Errore creazione chat",
      },
      chatMessages: {
        deleted: "Questo messaggio è stato eliminato",
        deletedAdmin: "Messaggio eliminato - visibile solo agli amministratori",
        reply: "Rispondi",
        edit: "Modifica",
        delete: "Elimina",
        forward: "Inoltra",
        editMessage: "Modifica Messaggio",
        save: "Salva",
        cancel: "Annulla",
        deleteMessage: "Elimina Messaggio",
        deleteMessageConfirm: "Sei sicuro di voler eliminare questo messaggio?",
        forwardMessage: "Inoltra Messaggio",
        selectChat: "Seleziona chat",
        doubleClickToReply: "Doppio click per rispondere",
        edited: "(modificato)",
        forwarded: "(inoltrato)",
        typeMessage: "Scrivi un messaggio...",
        send: "Invia",
        noMessages: "Nessun messaggio",
        loading: "Caricamento...",
        replyingTo: "Rispondendo a",
        clickToGoToOriginal: "Clicca per andare al messaggio originale",
        errorCreatingEditingChat: "Errore creazione/modifica chat",
      },
      chatPopover: {
        reply: "Rispondi",
        edit: "Modifica",
        delete: "Elimina",
        forward: "Inoltra",
        cancel: "Annulla",
        confirmDelete: "Conferma Eliminazione",
        confirm: "Conferma",
        deleteMessage: "Sei sicuro di voler eliminare questo messaggio?",
        editMessage: "Modifica Messaggio",
        save: "Salva",
        forwardMessage: "Inoltra Messaggio",
        selectChat: "Seleziona chat",
        forward: "Inoltra",
        noChats: "Nessuna chat disponibile",
      },
      chatIndex: {
        chats: "Chat",
        groups: "Gruppi",
        new: "Nuovo",
        messages: "Messaggi",
        search: "Cerca...",
        noChats: "Nessuna chat trovata",
        noGroups: "Nessun gruppo trovato",
        noMessages: "Nessun messaggio",
        loading: "Caricamento...",
        error: "Errore caricamento dati",
        addGroupPhoto: "Carica foto del gruppo",
        changeGroupPhoto: "Cambia Foto Gruppo",
        groupName: "Nome del gruppo",
        groupDescription: "Descrizione",
        save: "Salva",
        cancel: "Annulla",
        createGroup: "Crea Gruppo",
        editGroup: "Modifica Gruppo",
        deleteGroup: "Elimina Gruppo",
        deleteGroupConfirm: "Sei sicuro di voler eliminare questo gruppo?",
        edit: "Modifica",
        delete: "Elimina",
        details: "Dettagli",
        groupDetails: "Dettagli Gruppo",
        title: "Titolo",
        description: "Descrizione",
        modal: {
          title: "Crea Gruppo",
          editTitle: "Modifica Gruppo",
          subtitle: "Crea un gruppo interno e aggiungi rapidamente i partecipanti",
          save: "Salva",
          cancel: "Annulla",
          name: "Nome del gruppo",
          description: "Descrizione",
          filterUsers: "Cerca utenti da aggiungere",
          create: "Crea",
          edit: "Modifica",
        },
      },
      flowBuilder: {
        title: "Flussi di Conversazione",
        titleWithCount: "Flussi di Conversazione ({count})",
        searchPlaceholder: "Cerca flussi...",
        newFlow: "Nuovo Flusso",
        createFirstFlow: "Crea Primo Flusso",
        noFlowsFound: "Nessun flusso trovato",
        noFlowsCreated: "Nessun flusso ancora creato",
        tryOtherSearchTerms: "Prova altri termini di ricerca",
        createFirstFlowDescription: "Crea il tuo primo flusso di conversazione per automatizzare il servizio clienti",
        flowStatus: {
          active: "Attivo",
          inactive: "Inattivo"
        },
        flowActions: {
          edit: "Modifica",
          duplicate: "Duplica",
          delete: "Elimina",
          editFlow: "Modifica flusso",
          deleteFlow: "Elimina flusso"
        },
        confirmations: {
          deleteTitle: "Elimina flusso",
          deleteMessage: "Questa azione non può essere annullata. Tutte le integrazioni correlate verranno perse.",
          duplicateTitle: "Duplica flusso",
          duplicateMessage: "Verrà creata una copia del flusso per la modifica."
        },
        toasts: {
          flowDeleted: "Flusso eliminato con successo",
          flowDuplicated: "Flusso duplicato con successo",
          flowCreated: "Flusso creato con successo",
          flowUpdated: "Flusso aggiornato con successo",
          errorDeleting: "Errore eliminazione flusso",
          errorDuplicating: "Errore duplicazione flusso"
        },
        modal: {
          title: "Flusso di Conversazione",
          newFlow: "Nuovo Flusso",
          editFlow: "Modifica Flusso",
          flowName: "Nome Flusso",
          flowNamePlaceholder: "Inserisci nome flusso",
          save: "Salva",
          cancel: "Annulla"
        }
      },
      flowBuilderConfig: {
        title: "Editor Flusso",
        addNodes: "Aggiungi Nodi",
        startNode: {
          title: "Inizio flusso",
          description: "Questo blocco segna l'inizio del tuo flusso!"
        },
        categories: {
          basics: "Base",
          content: "Contenuto",
          interaction: "Interazione",
          logic: "Logica",
          system: "Sistema",
          integrations: "Integrazioni"
        },
        nodes: {
          start: {
            name: "Inizio",
            description: "Punto di partenza del flusso"
          },
          content: {
            name: "Contenuto",
            description: "Invia testo, immagine, audio o video"
          },
          text: {
            name: "Testo",
            description: "Messaggio di testo semplice"
          },
          menu: {
            name: "Menu",
            description: "Menu opzioni per utente"
          },
          input: {
            name: "Input",
            description: "Raccogli input utente"
          },
          interval: {
            name: "Intervallo",
            description: "Pausa esecuzione per tempo"
          },
          randomizer: {
            name: "Randomizzatore",
            description: "Selezione percorso casuale"
          },
          queues: {
            name: "Code",
            description: "Gestisci code servizio"
          },
          tags: {
            name: "Etichette",
            description: "Aggiungi etichette a contatto"
          },
          removeTag: {
            name: "Rimuovi Etichetta",
            description: "Rimuovi etichette dal contatto"
          },
          switchFlow: {
            name: "Cambia Flusso",
            description: "Passa ad altro flusso"
          },
          attendant: {
            name: "Agente",
            description: "Trasferisci ad agente"
          },
          closeTicket: {
            name: "Chiudi Ticket",
            description: "Termina servizio"
          },
          webhook: {
            name: "WebHook",
            description: "Integrazione HTTP"
          },
          webform: {
            name: "Webform",
            description: "Crea modulo web"
          },
          variable: {
            name: "Variabile",
            description: "Imposta variabili globali"
          },
          assign: {
            name: "Assegna",
            description: "Assegna chat ad agente"
          },
          openAI: {
            name: "OpenAI",
            description: "Integrazione OpenAI"
          },
          gemini: {
            name: "Gemini",
            description: "Integrazione Google Gemini"
          }
        },
        saveButton: "Salva Flusso",
        zoomIn: "Aumenta Zoom",
        zoomOut: "Riduci Zoom",
        flowSaved: "Flusso salvato con successo!",
        errorSaving: "Errore salvataggio flusso",
        seconds: "sec",
        modals: {
          menu: {
            addTitle: "Aggiungi menu al flusso",
            editTitle: "Modifica menu",
            addButton: "Aggiungi",
            saveButton: "Salva",
            cancelButton: "Annulla"
          },
          text: {
            addTitle: "Aggiungi testo al flusso",
            editTitle: "Modifica testo",
            addButton: "Aggiungi",
            saveButton: "Salva",
            cancelButton: "Annulla"
          },
          interval: {
            addTitle: "Aggiungi intervallo al flusso",
            editTitle: "Modifica intervallo",
            addButton: "Aggiungi",
            saveButton: "Salva",
            cancelButton: "Annulla"
          },
          image: {
            addTitle: "Aggiungi immagine al flusso",
            editTitle: "Modifica immagine",
            addButton: "Aggiungi",
            saveButton: "Salva",
            cancelButton: "Annulla"
          },
          audio: {
            addTitle: "Aggiungi audio al flusso",
            editTitle: "Modifica audio",
            addButton: "Aggiungi",
            saveButton: "Salva",
            cancelButton: "Annulla"
          },
          video: {
            addTitle: "Aggiungi video al flusso",
            editTitle: "Modifica video",
            addButton: "Aggiungi",
            saveButton: "Salva",
            cancelButton: "Annulla"
          }
        }
      },
      whitelabel: {
        primaryColorLight: "Colore Primario (Tema Chiaro)",
        primaryColorDark: "Colore Primario (Tema Scuro)",
        appName: "Nome Applicazione",
        logoLight: "Logo (Tema Chiaro)",
        logoDark: "Logo (Tema Scuro)",
        favicon: "Favicon",
        backgroundLight: "Sfondo (Tema Chiaro)",
        backgroundDark: "Sfondo (Tema Scuro)",
        preview: "Anteprima",
        delete: "Elimina",
        upload: "Carica",
        availableLanguages: "Lingue Disponibili",
        atLeastOneLanguage: "Almeno una lingua deve essere abilitata",
        sections: {
          general: "Configurazione Generale",
          generalDescription: "Configura il nome dell'applicazione e informazioni base",
          colors: "Colori e Temi",
          colorsDescription: "Personalizza colori primari per temi chiari e scuri",
          logos: "Loghi e Immagini",
          logosDescription: "Carica loghi e sfondi dell'applicazione",
          languages: "Lingue Disponibili",
          languagesDescription: "Seleziona quali lingue saranno disponibili nel sistema"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Report Supporto",
        ticketId: "ID Ticket",
        client: "Cliente",
        number: "Numero",
        agent: "Agente",
        date: "Data",
        lastMessage: "Ultimo Messaggio",
        fullReport: "Il report completo è allegato sopra",
        resolveAndTriggerIntegration: "Risolvi e Attiva Integrazione",
        elementNotFoundForExport: "Elemento non trovato per l'esportazione.",
        reportFilename: "report_supporto",
      },
    },
    salesReport: {
      title: "Report Vendite",
      filters: {
        startDate: "Data Inizio",
        endDate: "Data Fine",
        user: "Utente",
        allUsers: "Tutti gli utenti",
        search: "Cerca"
      },
      table: {
        attendant: "Agente",
        date: "Data",
        saleValue: "Valore Vendita",
        noSaleReason: "Motivo No Vendita",
        finalizationReason: "Motivo Finalizzazione",
        totalSales: "Totale Vendite",
        totalSalesValue: "Valore Totale Vendite",
        totalTickets: "Totale Ticket",
        details: "Dettagli",
        users: "Utenti",
        connections: "Connessioni",
        queues: "Code"
      }
    },
    placeholders: {
      chooseFlow: "Scegli un flusso",
      filterByTags: "Filtra per tag",
      departments: "Dipartimenti",
      searchTemplates: "Cerca Template",
      emailAddress: "Indirizzo email",
      contacts: "Contatti",
      tags: "Etichette",
      users: "Utenti",
      azureSpeechKey: "Chiave Servizio Voce Azure",
      search: "Cerca",
      selectOption: "Seleziona un'opzione",
      typeHere: "Scrivi qui",
      enterValue: "Inserisci valore",
      selectDate: "Seleziona data",
      chooseFile: "Scegli file"
    },
    validation: {
      required: "Richiesto",
      invalidEmail: "Email non valida",
      tooShort: "Troppo corto",
      tooLong: "Troppo lungo",
      minLength: "Minimo {{min}} caratteri",
      maxLength: "Massimo {{max}} caratteri",
      requiredField: "Campo richiesto",
      apiKeyRequired: "API Key richiesta",
      voiceModeRequired: "Modalità voce richiesta",
      voiceKeyRequired: "API Key Voce richiesta per sintesi vocale",
      voiceRegionRequired: "Regione Voce richiesta per sintesi vocale",
      keywordEmpty: "La parola chiave non può essere vuota",
      goalRequired: "Obiettivo richiesto quando autocompletamento è attivo",
      ratingRequired: "Valutazione richiesta"
    },
    toasts: {
      common: {
        error: "Errore elaborazione richiesta",
        success: "Operazione completata con successo",
        loading: "Caricamento...",
        warning: "Attenzione",
        info: "Informazione"
      },
      finalizacaoVenda: {
        informValue: "Inserisci importo vendita",
        ticketFinalized: "Ticket finalizzato con successo!",
        errorFinishing: "Errore finalizzazione ticket"
      },
      flowBuilder: {
        tagRemoved: "Etichetta rimossa con successo!",
        selectTag: "Seleziona un'etichetta da rimuovere",
        nodeAdded: "Nodo aggiunto al flusso",
        nodeRemoved: "Nodo rimosso dal flusso",
        flowSaved: "Flusso salvato con successo",
        errorSaving: "Errore salvataggio flusso"
      },
      tickets: {
        finalized: "Ticket finalizzato con successo!",
        errorFinalizing: "Errore finalizzazione ticket",
        transferred: "Ticket trasferito con successo",
        errorTransferring: "Errore trasferimento ticket",
        accepted: "Ticket accettato con successo",
        errorAccepting: "Errore accettazione ticket"
      },
      settings: {
        noPermission: "Nessun permesso per accedere!",
        saved: "Configurazione salvata con successo",
        errorSaving: "Errore salvataggio configurazione",
        fileRequired: "Scegli un file!",
        destinationRequired: "Scegli una destinazione!",
        fileSent: "File inviato con successo!",
        errorSending: "Errore invio file",
        invalidFormat: "Solo file formato p12 sono permessi!"
      },
      connections: {
        created: "Connessione creata con successo",
        updated: "Connessione aggiornata con successo",
        deleted: "Connessione eliminata con successo",
        errorCreating: "Errore creazione connessione",
        errorUpdating: "Errore aggiornamento connessione",
        errorDeleting: "Errore eliminazione connessione"
      },
      campaigns: {
        created: "Campagna creata con successo",
        updated: "Campagna aggiornata con successo",
        deleted: "Campagna eliminata con successo",
        started: "Campagna avviata con successo",
        paused: "Campagna messa in pausa con successo",
        errorCreating: "Errore creazione campagna",
        errorUpdating: "Errore aggiornamento campagna",
        errorDeleting: "Errore eliminazione campagna"
      },
      contacts: {
        imported: "Contatti importati con successo",
        exported: "Contatti esportati con successo",
        deleted: "Contatto eliminato con successo",
        errorImporting: "Errore importazione contatti",
        errorExporting: "Errore esportazione contatti",
        errorDeleting: "Errore eliminazione contatto"
      },
      dashboard: {
        createdTickets: "Ticket Creati"
      }
    },
    dialogs: {
      announcements: "Annunci",
      chooseColor: "Scegli un colore",
      finalizationValue: "Finalizzazione Servizio - Valore Vendita",
      editNote: "Modifica Nota",
      editMessage: "Modifica Messaggio",
      forwardMessage: "Inoltra Messaggio",
      chooseOption: "Scegli un'opzione",
      editBodyRequest: "Modifica corpo richiesta",
      fullApiResponse: "Risposta API completa",
      loadingSettings: "Caricamento impostazioni...",
      templateDetails: "Dettagli Template Selezionato",
      selectedTemplate: {
        name: "Nome",
        content: "Contenuto",
        language: "Lingua",
        category: "Categoria"
      }
    },
    forms: {
      labels: {
        openaiModel: "Modello OpenAI",
        geminiModel: "Modello Gemini",
        responseType: "Tipo Risposta",
        operationMode: "Modalità Operativa",
        selectChat: "Seleziona chat",
        selectCurrency: "Seleziona Valuta",
        attendant: "Agente",
        noSaleReason: "Motivo No Vendita",
        finalizationReason: "Motivo Finalizzazione",
        chooseAttendant: "Scegli un agente",
        whatsappConnections: "Connessioni WhatsApp",
        type: "Tipo",
        campaigns: "Campagne",
        sendAsRecordedAudio: "Invia come audio registrato",
        noSales: "Nessuna Vendita",
        welcomeFlow: "Flusso benvenuto",
        defaultResponseFlow: "Flusso risposta predefinita"
      }
    },
    flowDefaults: {
      welcomeFlowDescription: "Questo flusso si attiva solo per nuovi contatti, persone che non hai nella tua lista contatti e che hanno inviato un messaggio.",
      defaultResponseFlowDescription: "La risposta predefinita viene inviata per qualsiasi carattere diverso da una parola chiave. ATTENZIONE! Verrà attivata se il ticket è già chiuso."
    }
  },
};

export { messages };
